module.exports = __webpack_public_path__ + "assets/ico-doctor.77fb819e.svg";